export default {
  /**
   * 将数组转化为参数
   * 一般使用“~”分隔的字符串
   *
   * @param {Array} range 范围参数
   * @param {string} splitter 分隔符，默认为 “~”
   * @returns {string} 范围的API参数表达
   */
  parseRange2ApiParam(range, splitter = '~') {
    let value = range.join(splitter)
    return value === splitter ? null : value
  },
  /**
   * 将参数转化为组件需要的范围值
   *
   * @param {string} rangeParamStr 范围参数，如：1~10
   * @param {string} splitter 分隔符，默认为 “~”
   * @returns {Array} length 为 2 的数组
   */
  parseApiParam2Range(rangeParamStr, splitter = '~') {
    if (rangeParamStr === null || rangeParamStr === undefined) return ['', '']
    return rangeParamStr.split(splitter)
  },
  /**
   * 将日期范围参数转化为 picker使用的值
   *
   * @param {string} dateRangeParam API的日期范围参数
   * @returns {?Array<Date>} model 日期范围选择组件的数据模型
   */
  parseApiParam2DateRangePicker(dateRangeParam) {
    if (dateRangeParam === undefined) return null

    let dataRange = dateRangeParam.split('~')
    return [
      moment(dataRange[0]).toDate(),
      moment(dataRange[1])
        .endOf('day')
        .milliseconds(0) // 这一部分在 url/toString 上无法体现，所以都归 0 处理
        .toDate()
    ]
  },
  /**
   * 日期范围选择转化为API参数
   *
   * @param {?Array<Date>} model 日期范围选择组件的数据模型
   * @returns {string} API的日期范围参数
   */
  dateRangePicker2ApiParam(model) {
    if (model === null) {
      return null
    }

    let beginDateTime = model[0]
    let endDateTime = model[1]
    let beginDateStr = moment(beginDateTime).format('YYYY-MM-DD')
    let endDateStr = moment(endDateTime).format('YYYY-MM-DD')

    return `${beginDateStr}~${endDateStr}`
  },
  /**
   * 下拉选项显示变化，需要通知父组件
   * 一般适用于异步的下拉选项，值需要在高级查询这边获取，父组件无法获取
   *
   * @param {object} conditionSearchComponent 搜索面板
   * @param {object} asyncParamDisplays 异步的参数及显示值。基于当前值进行修改，返回所有。格式 { user_id: '小明' }
   * @param {Array} options 选项列表。格式 [{ id, name }]
   * @param {string} paramName 参数名
   * @param {string} paramValue 参数值
   */
  emitOptionDisplayUpdated(conditionSearchComponent, asyncParamDisplays, options, paramName, paramValue) {
    let option = options.find(option => option.id === paramValue)
    if (option) {
      asyncParamDisplays[paramName] = option.name
      conditionSearchComponent.$emit('param-display-updated', asyncParamDisplays)
    }
  },
  /**
   * 下拉选项显示变化，需要通知父组件
   * 一般适用于异步的下拉选项，值需要在高级查询这边获取，父组件无法获取
   *
   * @param {object} conditionSearchComponent 搜索面板
   * @param {object} asyncParamDisplays 异步的参数及显示值。基于当前值进行修改，返回所有。格式 { user_id: '小明' }
   * @param {string} paramName 参数名
   * @param {string} paramDisplayValue 显示的值
   */
  emitAsyncOptionDisplayUpdated(conditionSearchComponent, asyncParamDisplays, paramName, paramDisplayValue) {
    asyncParamDisplays[paramName] = paramDisplayValue
    conditionSearchComponent.$emit('param-display-updated', asyncParamDisplays)
  },
  /**
   * 将参数转化为字符串
   *
   * @param {object} params 参数
   * @returns {string} 参数拼接的字符串
   */
  params2String(params) {
    return new URLSearchParams(params).toString()
  },
  /**
   * 拼接参数到地址
   *
   * @param {string} url 基本网址
   * @param {object} params 参数
   * @returns {string} 完整URL
   */
  appendParams(url, params) {
    let paramsString = this.params2String(params)
    return url.includes('?') ? `${url}${paramsString}` : `${url}?${paramsString}`
  }
}
